/**
 * Tracks which table initiated a tournament add-on.
 *
 * The engine's `gotTnmAddon` success push (apps/engine/messages/inbound.js)
 * carries only `{ currentAddons, msg, title }` — NO gameID. In multi-table grid
 * view every open cell mounts its own AddOnChipsModal, all subscribed to the
 * one shared socket, so a single success event fired EVERY cell's listener and
 * the "Add-On Successful" modal popped on all tables at once.
 *
 * Since the payload can't be scoped server-side without changing the legacy
 * engine, we record the gameID of the table that fired the add-on request
 * (GameService.addOn) and let only that cell's modal react to the success. It's
 * a module-level singleton because the value is inherently global — there is
 * exactly one "most recently initiated add-on" across all cells, and the cells
 * each read it from their own React subtree (which have separate Global/Game
 * providers, so a context can't bridge them).
 */
let lastInitiatedGameID: string | null = null;

/** Record the table that just fired an add-on request. */
export const markAddOnInitiated = (gameID: string | number): void => {
  const id = String(gameID ?? '');
  lastInitiatedGameID = id !== '' ? id : null;
};

/** The table that initiated the pending add-on, or null if none/unknown. */
export const getAddOnInitiator = (): string | null => lastInitiatedGameID;

/** Clear the pending initiator once its success has been handled. */
export const clearAddOnInitiator = (): void => {
  lastInitiatedGameID = null;
};
